import getters from "./EtudeDeMarcheGetters";
import actions from "./EtudeDeMarcheActions";
import mutations from "./EtudeDeMarcheMutations";

const state = {
    moyenCommerciaux: {}
};

export default {
    state,
    getters,
    actions,
    mutations
};
